export const environment = {
  production: true,
  mapKay: 'AIzaSyCor5AFHyry5m9f-R0ySHv59lSZwNepdCE',
  serverData: 'https://data.zortrax.com/',
  serverImages: 'https://zortrax.com/static/img/find_reseller/',
  zortraxcom: 'https://zortrax.com/',
  spisAkcjiUrl: 'https://bd1.zortrax.com/submitForm',
};
